import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function Method() {
  const pillars = [{
    number: '01',
    title: 'Reconocer',
    desc: 'Mirar patrones, emociones y reacciones que se repiten, sin juicio y con honestidad.'
  }, {
    number: '02',
    title: 'Comprender',
    desc: 'Observar tu energía, tu diseño y la forma única en la que estás hecha para decidir, vincularte y expresarte.'
  }, {
    number: '03',
    title: 'Ordenar',
    desc: 'Traer conciencia a tu historia, tus cargas y tu lugar interno para volver a elegir desde más libertad.'
  }, {
    number: '04',
    title: 'Integrar',
    desc: 'Llevar lo aprendido a la vida real, practicarlo a tu ritmo y convertirlo, poco a poco, en sabiduría para vivir con más autenticidad.'
  }];
  return <section className="py-14 md:py-20 bg-brand-sage-light/30" data-id="element-115">
      <div className="max-w-6xl mx-auto px-6" data-id="element-116">
        <FadeIn data-id="element-117">
          <h2 className="font-serif text-3xl md:text-4xl text-center text-brand-ink mb-16" data-id="element-118">
            Un camino para recordar quién eres
          </h2>
        </FadeIn>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-119">
          {pillars.map((pillar, index) => <FadeIn key={index} delay={index * 0.15} className="h-full" data-id="element-120">
              <div className="h-full flex flex-col p-8 rounded-3xl bg-brand-warmwhite border border-brand-sand/50 shadow-sm" data-id="element-121">
                <span className="font-serif text-4xl text-brand-sage mb-6 block" data-id="element-122">
                  {pillar.number}
                </span>
                <h3 className="font-serif text-2xl text-brand-ink mb-4" data-id="element-123">
                  {pillar.title}
                </h3>
                <p className="font-sans text-brand-ink/80 leading-relaxed" data-id="element-124">
                  {pillar.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}